import { Api as StaticApi } from '@ori/static-api-client';
import { useCallback, useMemo } from 'react';
import { JOIN_TILES } from '../constants';
import { useConfigurationContext } from '../contexts/ConfigurationContext';
export var useFetchJoinTiles = function useFetchJoinTiles() {
  var _useConfigurationCont = useConfigurationContext(),
      tenant = _useConfigurationCont.tenant,
      staticApiUrl = _useConfigurationCont.staticApiUrl;

  var staticApiClient = useMemo(function () {
    return new StaticApi({
      baseUri: staticApiUrl
    });
  }, [staticApiUrl]);
  return useCallback(async function () {
    var responseNavigation = await staticApiClient.getTenantApplicationsNavigationNavigation(tenant, JOIN_TILES);
    return responseNavigation.navigationCollection;
  }, [staticApiClient, tenant]);
};